import * as Yup from "yup";

const validatePositiveNumber = value => {
  if (value === null || value === undefined || value === "") return true;

  // Converte vírgula para ponto apenas para validação
  const num =
    typeof value === "string"
      ? parseFloat(value.replace(",", "."))
      : parseFloat(value);

  return !isNaN(num) && num >= 0;
};

export const validationSchema = () => {
  return Yup.object().shape({
    goodQuantity: Yup.mixed()
      .nullable()
      .notRequired()
      .test(
        "isPositiveNumber",
        "Deve ser um número positivo",
        validatePositiveNumber
      ),
    diverseQuantity: Yup.mixed()
      .nullable()
      .notRequired()
      .test(
        "isPositiveNumber",
        "Deve ser um número positivo",
        validatePositiveNumber
      ),
    wasteQuantity: Yup.mixed()
      .nullable()
      .notRequired()
      .test(
        "isPositiveNumber",
        "Deve ser um número positivo",
        validatePositiveNumber
      ),
    wrongWeightQuantity: Yup.mixed()
      .nullable()
      .notRequired()
      .test(
        "isPositiveNumber",
        "Deve ser um número positivo",
        validatePositiveNumber
      )
  });
};
